//#region Libraries
import styled from "styled-components";
//#endregion
//#region Styles
import { TDefContent, ActionsCell } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion

export const CustomCell = styled(TDefContent)`
    & h5 {
        color: var(--dark-2);
    }
`;
export const CustomCellDate = styled(CustomCell)`
    min-width: 150px;
    & h5 {
        color: var(--dark-2);
    }
`;
export const CustomCellReason = styled(CustomCell)`
    & h5 {
        min-width: 250px;
        width: 100%;
        max-width: 300px;
        color: var(--dark-2);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;
export const CustomActionsCell = styled(ActionsCell)`
    min-width: 130px;
`;